<template>
  <div
    class="w-full max-w-[1340px] mx-auto mt-10 flex items-center justify-between tablet-h:border-t border-[#d4d8e1] tablet-h:pt-5"
  >
    <DacrWordLogo class="w-[95px] tablet-h:w-[108px]" />

    <div class="flex items-center gap-[30px]">
      <div
        class="hidden tablet-h:block font-medium text-[16px] leading-[24px] text-gray-800 text-right"
      >
        The new global standard for copyright
      </div>

      <RouterLink v-if="!userStore.isSignedIn" to="/register">
        <Button variant="stroke" :size="isMobileOrTablet ? 'lg' : 'md'">
          Get started
        </Button>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button } from '@dacr/library'
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { useDevice } from '@/shared/composables/useDevice'
import { useUserStore } from '@/shared/stores/user'

const device = useDevice()
const userStore = useUserStore()
const isMobileOrTablet = computed(
  () => device.isMobile.value || device.isTabletVertical.value
)
</script>
